import { Badge } from './badge';
import { cn } from '../lib/cn';

type Role = 'admin' | 'product' | 'project';

const styles: Record<Role, string> = {
  admin: 'border-transparent bg-amber-500/20 text-amber-200',
  product: 'border-transparent bg-blue-500/20 text-blue-200',
  project: 'border-transparent bg-emerald-500/20 text-emerald-200',
};

export function RoleBadge({ role, className }: { role: Role; className?: string }) {
  return <Badge className={cn(styles[role], className)}>{role}</Badge>;
}
